// Mock data for M.Plaisir Marseille - real menu & prices from official flyer

export const restaurant = {
  name: "M.Plaisir",
  tagline: "By Dragon Food",
  subtitle: "Nouveau propriétaire · Nouvelles saveurs",
  phone: "07 68 31 43 56",
  address: "110 Boulevard Saint Marcel, 13011 Marseille",
  website: "www.mplaisirmarseille.fr",
  freeDeliveryFrom: 15,
  hours: [
    { day: "Dimanche au Jeudi", time: "11h00 – 02h00" },
    { day: "Vendredi & Samedi", time: "11h00 – 03h00" },
  ],
  platforms: ["Uber Eats", "Deliveroo", "Just Eat"],
  socials: { facebook: "#", instagram: "#", snapchat: "#" },
};

const U = (id) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=800`;
const P = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800`;

const IMG = {
  // burgers
  burger1: U("photo-1572802419224-296b0aeee0d9"),
  burger2: U("photo-1586190848861-99aa4a171e90"),
  burgerWhite: U("photo-1549611016-3a70d82b5040"),
  burgerBoard: P("15010285"),
  gourmet1: U("photo-1610970878459-a0e464d7592b"),
  gourmet2: P("34407507"),
  // tacos
  tacos1: U("photo-1565299585323-38d6b0865b47"),
  tacos2: P("38932103"),
  tacosWrap: U("photo-1621334953222-c60c19143b0a"),
  tacosTray: U("photo-1613319300832-a105da5bd34e"),
  // chicken buckets / wings / tenders
  wings1: U("photo-1567620832903-9fc6debc209f"),
  wings2: U("photo-1637273484026-11d51fb64024"),
  // kebab / plates
  kebab1: U("photo-1733507100601-323ca84d7277"),
  kebab2: P("38337105"),
  kebabPlate: U("photo-1653982960203-c8361d7bed96"),
  kebabSkewers: U("photo-1603360946369-dc9bb6258143"),
  grilledMeat: U("photo-1532636875304-0c89119d9b4d"),
  // panini / salad
  panini: U("photo-1705537459006-f4acbd93c5a3"),
  caesar: U("photo-1550304943-4f24f54ddde9"),
  // vraies photos M.Plaisir (fournies par le client)
  kebabReal: "/menu/kebab.png",
  boursinReal: "/menu/boursin.png",
  troisFromagesReal: "/menu/trois-fromages.jpeg",
  tacosReal: "/menu/tacos.jpg",
  kidsReal: "/menu/kids.png",
  cheeseReal: "/menu/cheese.png",
  doubleCheeseReal: "/menu/doublecheese.png",
  tripleCheeseReal: "/menu/triplecheese.png",
  chickenReal: "/menu/chicken.png",
  bigMReal: "/menu/bigm.png",
  fishReal: "/menu/fish.png",
  duo1Real: "/menu/duo1.png",
  duoP2: "/menu/a4.png",
  duoP3: "/menu/a5.png",
  duoP4: "/menu/a6.png",
  duoP9: "/menu/a3.png",
  duoP12: "/menu/a7.png",
  duoP5: "/menu/p5.png",
  duoP6: "/menu/p6.png",
  duoP7: "/menu/p7.png",
  duoP10: "/menu/p10.png",
  duoP11: "/menu/p11.png",
  duoP8: "/menu/p8.png",
  bucketWings: "/menu/bucket_wings.png",
  bucketTenders: "/menu/bucket_tenders.png",
  miniTenders: "/menu/mini_tenders.png",
  doubleCheeseNew: "/menu/doublecheese_new.png",
  tripleCheeseNew: "/menu/triplecheese_new.png",
  chickenNew: "/menu/chicken_new.png",
  fishNew: "/menu/fish_new.png",
  giantNew: "/menu/giant_new.png",
  bigMNew: "/menu/bigm_new.png",
  bigMBacon: "/menu/bigm_bacon.png",
  saladeCesar: "/menu/salade_cesar.png",
  royaleChevre: "/menu/royale_chevre.png",
  brownReal: "/menu/brown.png",
  paniniNew: "/menu/panini_new.png",
  leMaxi: "/menu/le_maxi.png",
  commandoReal: "/menu/commando.png",
  berne1Real: "/menu/berne1.png",
  tendersNew: "/menu/tenders_new.png",
  wingsNew: "/menu/wings_new.png",
  mythicReal: "/menu/mythic.png",
  berne2Real: "/menu/berne2.png",
  kebab3Fromages: "/menu/kebab3fromages.png",
  cheeseNew: "/menu/cheese_new.png",
  boursinNew: "/menu/boursin_new.png",
  leJalat: "/menu/le_jalat.png",
  hummerReal: "/menu/hummer.png",
  // tex mex
  nuggets1: P("11710531"),
  nuggets2: U("photo-1562967916-eb82221dfb92"),
  mozza1: "https://images.unsplash.com/photo-1734774924912-dcbb467f8599?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  mozza2: "https://images.unsplash.com/photo-1623653387945-2fd25214f8fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  onion1: "https://images.unsplash.com/photo-1639024471283-03518883512d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  onion2: "https://images.unsplash.com/photo-1625938146369-adc83368bda7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  // drinks
  soda1: "https://images.unsplash.com/photo-1674176508097-463b009c6004?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  soda2: "https://images.unsplash.com/photo-1544241907-f3f1f5ded15a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  soda3: "https://images.unsplash.com/photo-1581636625402-29b2a704ef13?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  // desserts
  tiramisu: "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  choco1: "https://images.unsplash.com/photo-1590080875852-ba44f83ff2db?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  choco2: "https://images.unsplash.com/photo-1673551494277-92204546b504?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  fries: U("photo-1630384060421-cb20d0e0649d"),
};
export { IMG };

// Choice lists
export const VIANDES_TACOS = ["Viande hachée", "Tenders", "Poulet", "Kebab", "Cordon bleu", "Nuggets"];
export const VIANDES_ASSIETTE = ["Escalope", "Steak", "Cordon bleu", "Nuggets", "Tenders", "Kebab"];
export const SAUCES = ["Blanche", "Algérienne", "Samouraï", "Harissa", "Ketchup", "Mayonnaise", "Barbecue", "Biggy", "Curry", "Andalouse", "Fromagère", "Chili Thaï"];
export const BOISSONS = ["Coca-Cola", "Coca-Cola Zéro", "Coca-Cola Cherry", "Fanta Orange", "Fanta Citron", "Oasis Tropical", "Ice Tea", "7 Up", "Orangina", "Sprite", "Perrier", "Cristaline"];
export const CRUDITES = ["Salade", "Tomate", "Oignons"];
export const SUPPORTS = ["Pain normal", "Pain galette"];

// helper builder
let _id = 0;
const it = (name, seul, menu, desc, image, opts = {}) => ({
  id: `it-${++_id}`,
  name, seul, menu, desc, image,
  meat: opts.meat || null,
  meatList: opts.meatList || null,
  sauce: opts.sauce ?? (seul || menu ? true : false),
  badge: opts.badge || null,
  comingSoon: opts.comingSoon || false,
});

export const categories = [
  {
    id: "sandwichs", label: "Nos Sandwichs", icon: "Sandwich", image: IMG.kebabReal,
    items: [
      it("Kebab", 6.5, 8.0, "Crudités et sauce au choix.", IMG.kebabReal),
      it("Le Boursin", 8.5, 9.9, "Escalope au boursin.", IMG.boursinNew),
      it("Le Maxi", 9.0, 10.5, "Steak, kebab, fromage.", IMG.leMaxi),
      it("Berne 1", 8.5, 9.9, "2 steaks 45g, œuf, jambon, cheddar.", IMG.berne1Real),
      it("Kebab 3 Fromages", 8.5, 9.9, "Sauce 3 fromages et crudités.", IMG.kebab3Fromages),
      it("Commando", 8.5, 9.9, "2 steaks, galette de PDT, fromage.", IMG.commandoReal),
      it("3 Fromages", 8.5, 9.9, "Escalope, sauce 3 fromages, crudités.", IMG.troisFromagesReal),
      it("Berne 2", 8.9, 10.9, "2 steaks 45g, œuf, jambon, GPT, cheddar.", IMG.berne2Real),
      it("Mythic", 9.0, 10.5, "2 steaks 45g, cordon bleu, cheddar.", IMG.mythicReal),
      it("Le Jalat", 8.5, 9.9, "Jalapenos, tenders, cheddar.", IMG.leJalat),
    ],
  },
  {
    id: "burgers", label: "Nos Burgers", icon: "Beef", image: IMG.burger1,
    items: [
      it("Cheese", 4.5, 5.9, "Steak, cheddar, sauce au choix.", IMG.cheeseNew),
      it("Double Cheese", 5.5, 7.9, "2 steaks, double cheddar.", IMG.doubleCheeseNew),
      it("Triple Cheese", 7.0, 8.9, "3 steaks, triple cheddar.", IMG.tripleCheeseNew),
      it("Chicken", 5.5, 7.0, "Galette de poulet crousti.", IMG.chickenNew),
      it("Fish", 6.5, 8.0, "Filet de poisson pané.", IMG.fishNew),
      it("Giant", null, 8.0, "Le plus gourmand.", IMG.giantNew),
      it("Big M", 6.9, 8.5, "Le classique signature M.Plaisir.", IMG.bigMNew, { badge: "Best" }),
      it("Maxi Country", null, 9.5, "Steak, bacon, cheddar, oignons.", IMG.gourmet1),
      it("Big M Bacon", 8.0, 9.9, "Big M version bacon.", IMG.bigMBacon),
      it("Country", 7.5, 8.5, "Steak, cheddar, sauce country.", IMG.burgerWhite),
    ],
  },
  {
    id: "gourmets", label: "Nos Gourmets", icon: "Crown", image: IMG.gourmet1,
    items: [
      it("Royal Chèvre", 7.5, 9.0, "Steak, chèvre, miel, fromage.", IMG.royaleChevre),
      it("Brown", 8.5, null, "Steak, GPT, bacon, œuf, cheddar.", IMG.brownReal),
      it("Maxi Brown", 9.0, 10.5, "2 steaks, GPT, œuf, cheddar.", IMG.burgerBoard, { comingSoon: true }),
    ],
  },
  {
    id: "tacos", label: "Nos Tacos", icon: "Wheat", image: IMG.tacos1,
    items: [
      it("Tacos Simple", 6.9, 8.9, "1 viande au choix, sauce fromagère.", IMG.tacosReal, { meat: 1, meatList: VIANDES_TACOS }),
      it("Tacos Double", 8.9, 9.9, "2 viandes au choix, sauce fromagère.", IMG.tacosReal, { meat: 2, meatList: VIANDES_TACOS, badge: "Best" }),
      it("Tacos Triple", 9.9, 11.9, "3 viandes au choix, sauce fromagère.", IMG.tacosReal, { meat: 3, meatList: VIANDES_TACOS }),
      it("Menu Kids", 5.9, null, "1 Cheese ou 4 nuggets, 1 frite, 1 Capri-Sun.", IMG.kidsReal, { sauce: false }),
    ],
  },
  {
    id: "hummers", label: "Nos Hummers", icon: "Layers", image: IMG.gourmet1,
    items: [
      it("Hummer X1", 7.0, 8.5, "2 steaks, jambon, œuf, crudités.", IMG.hummerReal),
      it("Hummer X3", 9.0, 10.5, "4 steaks, jambon, œuf, crudités.", IMG.hummerReal),
      it("Hummer X5", 10.5, 12.0, "6 steaks, jambon, œuf, crudités.", IMG.hummerReal),
    ],
  },
  {
    id: "duos", label: "Nos Duos", icon: "Users", image: IMG.burger2, note: "Avec frites et boisson",
    items: [
      it("P1", null, 9.0, "Cheese + Cheese.", IMG.cheeseReal, { sauce: false }),
      it("P2", null, 10.5, "Cheese + Double Cheese.", IMG.duoP2, { sauce: false }),
      it("P3", null, 11.5, "Cheese + Triple Cheese.", IMG.duoP3, { sauce: false }),
      it("P4", null, 11.5, "Cheese + Big M.", IMG.duoP4, { sauce: false }),
      it("P5", null, 12.5, "Chicken + Big M.", IMG.duoP5, { sauce: false }),
      it("P6", null, 13.0, "Big M + 6 Nuggets.", IMG.duoP6, { sauce: false }),
      it("P7", null, 12.5, "Cheese + Country.", IMG.duoP7, { sauce: false }),
      it("P8", null, 10.5, "Chicken + 3 Tenders.", IMG.duoP8, { sauce: false }),
      it("P9", null, 9.0, "Fish + Fish.", IMG.duoP9, { sauce: false }),
      it("P10", null, 14.0, "Big M + Big M.", IMG.duoP10, { sauce: false }),
      it("P11", null, 15.0, "Country + Big M.", IMG.duoP11, { sauce: false }),
      it("P12", null, 13.0, "Giant + Big M.", IMG.duoP12, { sauce: false }),
    ],
  },
  {
    id: "bucket", label: "Bucket Family", icon: "Drumstick", image: IMG.wings1,
    items: [
      it("Mini Menu Tenders", null, 15.5, "10 tenders, 2 frites, 2 canettes.", IMG.miniTenders, { sauce: false }),
      it("Mini Menu Wings", null, 14.9, "10 wings, 2 frites, 2 canettes.", IMG.wings1, { sauce: false }),
      it("Big Bucket Wings", null, 26.5, "20 wings, 4 frites, bouteille 1.5L.", IMG.bucketWings, { sauce: false, badge: "Family" }),
      it("Big Bucket Tenders", null, 26.9, "20 tenders, 4 frites, bouteille 1.5L.", IMG.bucketTenders, { sauce: false, badge: "Family" }),
    ],
  },
  {
    id: "texmex", label: "Tex Mex", icon: "Flame", image: IMG.nuggets2,
    items: [
      it("Assortiment x3", 3.9, null, "Jalapenos, mozza sticks, oignon rings, camembert ou nuggets.", IMG.mozza1, { sauce: false }),
      it("Assortiment x6", 6.0, null, "Jalapenos, mozza sticks, oignon rings, camembert ou nuggets.", IMG.onion1, { sauce: false }),
      it("Assortiment x9", 8.0, null, "Jalapenos, mozza sticks, oignon rings, camembert ou nuggets.", IMG.mozza2, { sauce: false }),
      it("Tenders", 6.5, 7.9, "Tenders crousti à la sauce.", IMG.tendersNew),
      it("Wings", 6.5, 7.9, "Wings épicées.", IMG.wingsNew),
    ],
  },
  {
    id: "assiettes", label: "Nos Assiettes", icon: "UtensilsCrossed", image: IMG.kebabPlate,
    items: [
      it("Assiette 1 Viande", 10.0, null, "1 viande au choix, frites, salade tomates & oignons.", IMG.kebabPlate, { meat: 1, meatList: VIANDES_ASSIETTE, comingSoon: true }),
      it("Assiette 2 Viandes", 12.0, null, "2 viandes au choix, frites, salade tomates & oignons.", IMG.kebabSkewers, { meat: 2, meatList: VIANDES_ASSIETTE, comingSoon: true }),
      it("Assiette 3 Viandes", 13.5, null, "3 viandes au choix, frites, salade tomates & oignons.", IMG.grilledMeat, { meat: 3, meatList: VIANDES_ASSIETTE, comingSoon: true }),
    ],
  },
  {
    id: "paninis", label: "Nos Paninis", icon: "Sandwich", image: IMG.paniniNew,
    items: [
      it("Panini Jambon", 6.4, 7.5, "Jambon, fromage, sauce au choix.", IMG.paniniNew),
      it("Panini 3 Fromages", 6.4, 7.5, "Trio de fromages fondants.", IMG.paniniNew),
      it("Panini Steak", 6.4, 7.5, "Steak, fromage, sauce au choix.", IMG.paniniNew),
      it("Panini Kebab", 6.4, 7.5, "Kebab, fromage, sauce au choix.", IMG.paniniNew),
    ],
  },
  {
    id: "salades", label: "Salade César", icon: "Salad", image: IMG.saladeCesar,
    items: [
      it("Salade César", 6.0, 7.0, "Salade, tomates, maïs, poulet pané, croûtons.", IMG.saladeCesar, { sauce: false }),
    ],
  },
  {
    id: "boissons", label: "Boissons", icon: "CupSoda", image: IMG.soda1,
    items: BOISSONS.map((b, i) => it(b, 1.5, null, "Canette 33cl.", [IMG.soda1, IMG.soda2, IMG.soda3][i % 3], { sauce: false })),
  },
  {
    id: "desserts", label: "Desserts", icon: "IceCream", image: IMG.tiramisu,
    items: [
      it("Tiramisu Classique", 3.0, null, "Onctueux et généreux.", IMG.tiramisu, { sauce: false }),
      it("Fondant au Chocolat", 3.0, null, "Cœur coulant chocolat.", IMG.choco1, { sauce: false }),
      it("Tarte au Daim", 3.0, null, "Caramel & éclats de Daim.", IMG.choco2, { sauce: false }),
    ],
  },
];

// Crudités offertes pour tous les sandwichs (salade, tomate, oignons)
categories.find((c) => c.id === "sandwichs").items.forEach((i) => { i.crudites = true; i.support = true; });

export const featured = [
  { title: "Le Big M", subtitle: "Notre signature", price: "dès 6,90€", image: IMG.burger2, tag: "Best of" },
  { title: "Tacos Double", subtitle: "2 viandes au choix", price: "dès 8,90€", image: IMG.tacos1, tag: "Best of" },
  { title: "Big Bucket Wings", subtitle: "À partager", price: "26,50€", image: IMG.wings1, tag: "Family" },
  { title: "Royal Chèvre Miel", subtitle: "Gourmet", price: "dès 7,50€", image: IMG.gourmet1, tag: "Best of" },
];
